import React from 'react';
import { cn } from '../../lib/utils';

interface ResponsiveTableProps {
  children: React.ReactNode;
  className?: string;
  mobileStack?: boolean; // Whether to stack content on mobile
}

export const ResponsiveTable: React.FC<ResponsiveTableProps> = ({
  children,
  className,
  mobileStack = true,
}) => {
  return (
    <div className={cn(
      'overflow-x-auto',
      mobileStack && '-mx-4 sm:mx-0', // Negative margin on mobile for full-width scrolling
      className
    )}>
      <table className="w-full min-w-full">
        {children}
      </table>
    </div>
  );
};

export default ResponsiveTable;
